module.exports = __webpack_public_path__ + "img/discrepancy.1dc7ab07.png";